$(document).ready ->
  file_preview = $(".upload-thumbnail img")
  video_preview = $(".play")
  video_capture_preview = $(".capture")
  count = 1

  fileObject = {}
  
  $('#new_video_page').submit (e) ->
    if $('#video_page_page_attributes_name').val() == ''
      alert 'Name can\'t be blank'
      e.preventDefault()
      return false
    return
  
  $(".file-thumbnail").change (event) ->
    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filetype = file.type;
    fileObject.filename = file.name;
    
    reader = new FileReader()

    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64
      
      if $('.edit_video_page')
        $("#video_page_thumbnail_capture_time").val("0")
      
      return
    reader.readAsDataURL file
    return
    
  $(".new-video").change (event) ->
    if $(this)[0].files[0] && (($(this)[0].files[0].size) / 1024 / 1024) > 90
      $(this).val('')
      alert "Uploaded video exceeds maximum file size of 90MB"
    else if $(this)[0].files[0]
      input = $(event.currentTarget)
      file = input[0].files[0]
      fileObject.filetype = file.type;
      fileObject.filename = file.name;
      video = $(this)

      reader = new FileReader()

      reader.onload = (e) ->
        image_base64 = e.target.result
        image_base64 = image_base64.replace("quicktime","mp4")
        $(".play:visible").attr "src", image_base64
        $(video).parents('.image-container').find('#modal-thumbnail-selection').parent().css("display", "block")
        $(video).parents('.image-container').find('.remove_video_page_video').css("display", "block")
        $(video).parents('.image-container').find('.modal-thumbnail-selection').css("display", "block")
        return
      reader.readAsDataURL file
    return
    
  $(".edit-video").change (event) ->
    if $(this)[0].files[0] && (($(this)[0].files[0].size) / 1024 / 1024) > 90
      $(this).val('')
      alert "Uploaded video exceeds maximum file size of 90MB"
    else if $(this)[0].files[0]
      video = $(this)
      input = $(event.currentTarget)
      file = input[0].files[0]
      fileObject.filetype = file.type;
      fileObject.filename = file.name;
      video = $(this)

      reader = new FileReader()

      reader.onload = (e) ->
        image_base64 = e.target.result
        image_base64 = image_base64.replace("quicktime","mp4")
        $(".play:visible").attr "src", image_base64
        $(".play:visible").get(0).removeAttribute("crossorigin");
        $(".play:visible").attr('poster', '')
        $(video).parents('.image-container').find('#modal-thumbnail-selection').parent().css("display", "block")
        $(video).parents('.image-container').find('.remove_video_page_video').css("display", "block")
        $(video).parents('.image-container').find('.modal-thumbnail-selection').css("display", "block")
        return
      reader.readAsDataURL file
    return

  $(".video-subtitles").change (event) ->
    if $(this)[0].files[0]
      input = $(event.currentTarget)
      file = input[0].files[0]

      $(this).siblings('.video-subtitles-file').show()
      $(this).siblings('.video-subtitles-file').find('h4').text(file.name)

    return
  
  $('.modal-thumbnail-selection').click (event) ->
    $('#modal_thumbnail_selection_'+$('#page_language_selection').val()).openModal()
    $("#video_thumbnail_modal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');
    video = $(this).parent().siblings('.photowall').find('video').get(0)
    generate_default_thumbnail(video)

  $('.remove_video_page_video').click (event) ->
    $(this).parents('.image-container').find('.edit-video').val('')
    $(this).parents('.image-container').find('.new-video').val('')
    video = $(this).parents('.image-container').find('video')
    video.attr("src", '')
    video.attr("src",null)
    video.find('source').attr("src",null)
    video.attr("poster", '')
    $(this).css("display", "none")
    $(this).parents('.image-container').find('.modal-thumbnail-selection').css("display", "none")
    language_id = $(this).data('language-id')
    if language_id
      $("#remove_page_video_" + language_id).val(true)
  
  $('.thumbnail-checkbox-switch').click (event) ->
    selected_language = $('#page_language_selection').val();
    main_div = $("#modal_thumbnail_selection_"+selected_language)
    if !($(event.target)[0].checked)
      main_div.find('#thumbnail-capture-area').css('opacity', '1')
      main_div.find('#thumbnail-capture-area').css({pointerEvents: "all"})
      main_div.find('#snapshot-button').css('opacity', '1')
      main_div.find('#snapshot-button').css({pointerEvents: "all"})
      main_div.find('#thumbnail-upload-area').css('opacity', '0.5')
      main_div.find('#thumbnail-upload-area').css({pointerEvents: "none"})
      main_div.find("#video_page_thumbnail_capture_time").val("0")
    else
      main_div.find('#thumbnail-capture-area').css('opacity', '0.5')
      main_div.find('#thumbnail-capture-area').css({pointerEvents: "none"})
      main_div.find('#snapshot-button').css('opacity', '0.5')
      main_div.find('#snapshot-button').css({pointerEvents: "none"})
      main_div.find('#thumbnail-upload-area').css('opacity', '1')
      main_div.find('#thumbnail-upload-area').css('pointer-events', 'all')
      main_div.find('#video_page_thumbnail_'+$('#page_language_selection').val().toString()).val(null)
      main_div.find('.display-thumbnail-1 img').css("border", "3px solid #ccc")
      main_div.find('.display-thumbnail-2 img').css("border", "3px solid #ccc")
      main_div.find('.display-thumbnail-3 img').css("border", "3px solid #ccc")
      main_div.find('.display-thumbnail-4 img').css("border", "3px solid #ccc")
    return

  $(".choose-video-page-thumbnail-btn").click (event) ->
    $(this).parents('.file-upload-area').find('.file-thumbnail').click()

  $(".capture-thumbnail").click (event) ->
    video = $(this).parent().siblings('video').get(0)
    if video != undefined
      preview = '#display-thumbnail-' + count.toString() + '-' + $('#page_language_selection').val().toString() + ' img'
      canvas = document.createElement('canvas')
      context = canvas.getContext('2d')
      context.canvas.width = video.videoWidth
      context.canvas.height = video.videoHeight
      context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight)
      try
        dataURL = canvas.toDataURL()
        $(preview).attr("src", dataURL)
        $(preview).css("border", "3px solid #ccc")
        $('#video_page_thumbnail_'+$('#page_language_selection').val().toString()).val(null)
        count = count + 1
        if count > 4
          count = 1
      catch err
        console.log (err.message)
    return

  $('.display-thumbnail-selection').click (event) ->
    $('.display-thumbnail-1 img').css("border", "3px solid #ccc")
    $('.display-thumbnail-2 img').css("border", "3px solid #ccc")
    $('.display-thumbnail-3 img').css("border", "3px solid #ccc")
    $('.display-thumbnail-4 img').css("border", "3px solid #ccc")
    $(this).find('.video-thumbnail-selector').css("border", "3px solid #8DC937")
    if !!$(event.target).attr("src")
      $('#video_page_thumbnail_'+$('#page_language_selection').val()).val($(event.target).attr("src").replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, ""))
    return
    
  $('.video_pages .mandatory-answer-page-submit').click (event) ->
    $('#loading-modal').openModal({dismissible: false})
    return
  return
  
generate_default_thumbnail = (vid) ->
  video = vid
  count = 1
  if video != undefined
    total_time = video.duration
    seek_time = 0.2
    while count < 5 && !!total_time
      video.currentTime = (seek_time * total_time)
      preview = '#display-thumbnail-' + count.toString()+ '-' + $('#page_language_selection').val().toString() + ' img'
      canvas = document.createElement('canvas')
      context = canvas.getContext('2d')
      context.canvas.width = video.videoWidth
      context.canvas.height = video.videoHeight 
      context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight)
      try
        dataURL = canvas.toDataURL()
        $(preview).attr("src", dataURL)
        $(preview).css("border", "3px solid #ccc")
        $('#video_page_thumbnail_' + $('#page_language_selection').val().toString()).val(null)
      catch err
        console.log (err.message)
      count = count + 1
      seek_time = seek_time + 0.2
    count = 1
    video.currentTime = 0
  return